<template>
  <div>
  <b-container>
    
    <form @submit.prevent="submit">
        <b-row class="justify-content-md-center" align-h="center">
          <b-col cols="12" sm="10" md="4">
            <h2>Reset Your Password</h2>
            <b-alert :show="success" variant="success" >
                Success! Check your email and use the verification link to reset your password.
            </b-alert>
            <b-alert :show="error_msg != null" variant="danger">{{error_msg}}</b-alert>
            <b-form-group
              :state="!$v.email.$invalid"
              :invalid-feedback="emailError">
              <b-form-input v-model="email"
                :state="!$v.email.$invalid"
                type="text"
                placeholder="Email">
              </b-form-input>
            </b-form-group>
            
            <b-form-group>
              <b-button type="submit" variant="primary" :disabled="$v.$invalid" >Send Reset Password Link<icon scale="1" v-show="loading" name="spinner" spin></icon></b-button>
              <b-button @click="goToLogin" variant="secondary">Cancel</b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-container>
  </div>
</template>

<script>
  import api from '../api'
  import { required, email } from 'vuelidate/lib/validators'

  // Minimum eight characters, at least one letter, one number and one special character
  let pass_regex = value => { return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/.test(value) }

  export default {
    data () {
      return {
        email:'',
        success: false,
        error_msg: null,
        loading: false
      }
    },
    computed: {
      emailError() {
        if(!this.$v.email.required) {
          return "Email is required"
        } else if (!this.$v.email.email) {
          return "Email is invalid"
        }
      }
    },
    validations: {
        email: {
          email,
          required
        }
    },
    methods: {
      goToLogin() {
          this.$router.replace('/login')
      },
      send_code() {
        if(this.email.indexOf('@') < 0){
          this.error_msg = 'Email Required'
          return
        }
        api.resetPassword(this.email)
      },
      submit () {
        this.error_msg = null
        this.loading = true
        var that = this
        api.resetPassword(this.email.trim())
          .then(response => {
            that.loading = false
            that.success = true
          }).catch(error => {
            that.error_msg = error.response.data.ret_msg
            that.loading = false
          })
      }
    }
  }
</script>

<style scoped>
  .error {
    color: red;
    font-size: 0.8em;
  }
  .info {
    font-size: 0.8em;
  }
</style>


// WEBPACK FOOTER //
// src/components/ResetPassword.vue